import { render, staticRenderFns } from "./detailView.vue?vue&type=template&id=65b7f00a&scoped=true"
import script from "./detailView.vue?vue&type=script&lang=js"
export * from "./detailView.vue?vue&type=script&lang=js"
import style0 from "./detailView.vue?vue&type=style&index=0&id=65b7f00a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b7f00a",
  null
  
)

export default component.exports